/**
 * App notifications (top-right toasts).
 * Usage:
 *   this.$notify.success("Listo")
 *   this.$notify.danger("Falló", { title: "Error", timeout: 6000 })
 *   this.$notify.info({ title: "Aviso", text: "Detalle" })
 *   this.$notify.warning({ title: "Atención", text: "..." })
 */
function stripHtml(value) {
  return String(value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function buildMessage(input = {}, fallback = "Aviso") {
  if (typeof input === "string") {
    return stripHtml(input) || fallback;
  }

  const title = stripHtml(input.title);
  const text = stripHtml(input.text ?? input.message ?? input.footer);
  if (title && text && title !== text) return `${title} — ${text}`;
  return title || text || fallback;
}

function buildOptions(input = {}, extra = {}) {
  const source = typeof input === "string" ? extra : { ...input, ...extra };
  const timeout =
    typeof source.timeout === "number"
      ? source.timeout
      : typeof source.timer === "number"
        ? source.timer
        : 4000;
  return { timeout };
}

export function createNotify(toast) {
  const show = (type, input, extra) => {
    const message = buildMessage(input);
    const options = buildOptions(input, extra);

    if (type === "success") return toast.success(message, options);
    if (type === "warning") return toast.warning(message, options);
    if (type === "info") return toast.info(message, options);
    // danger / error
    return toast.error(message, options);
  };

  return {
    success(input, extra) {
      return show("success", input, extra);
    },
    warning(input, extra) {
      return show("warning", input, extra);
    },
    info(input, extra) {
      return show("info", input, extra);
    },
    danger(input, extra) {
      return show("danger", input, extra);
    },
    error(input, extra) {
      return show("danger", input, extra);
    },
    show({ type = "info", ...rest } = {}) {
      const normalized =
        type === "error" || type === "danger"
          ? "danger"
          : type === "success" || type === "warning" || type === "info"
            ? type
            : "info";
      return show(normalized, rest);
    },
  };
}
